import { Cell } from '@tanstack/react-table';
import { MentorshipProgramCustomCommunication } from 'redux/schemas/models/mentorship-program-custom-communications';

export enum ColumnID {
  MESSAGE_TYPE = 'messageType',
  SUBJECT = 'subject',
  TO = 'to',
  STATUS = 'status',
  OPTIONS = 'options',
}

export type CellProps = {
  className: string,
  cell: Cell<MentorshipProgramCustomCommunication, any>;
};
